import { Button } from '@mantine/core';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ROUTES } from 'configs/routes';
import { userStore } from 'stores/global/RootStore';
import { createFullNameShort } from 'utils/createFullName';

import s from './Profile.module.scss';

type ProfileProps = {
  className?: string;
};

const isProfilePath = (pathname: string): boolean => {
  const profilePath = ROUTES.lk.profile.path;

  return pathname === profilePath || pathname.startsWith(`${profilePath}/`);
};

const Profile: React.FC<ProfileProps> = ({ className }) => {
  const { user } = userStore;
  const { pathname } = useLocation();
  const isCurrentPage = isProfilePath(pathname);

  if (!user) {
    return null;
  }

  const buttonProps = {
    className: cn(s.root, isCurrentPage && s.root_current, className),
    variant: 'light' as const,
    size: 'sm' as const,
    h: 36,
    children: createFullNameShort(user),
  };

  if (isCurrentPage) {
    return <Button {...buttonProps} component="span" aria-current="page" />;
  }

  return <Button {...buttonProps} component={Link} to={ROUTES.lk.profile.create()} />;
};

export default observer(Profile);
